import React, {ReactElement, useContext} from "react";
import "../../../../Assets/Css/Pages/User/WZ/filters.css";
import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {UserContext} from "../../../../Contexts/UserContext";
import {DataPeriod, DateRange, DocumentType, ProductEAN, ProductIndex, ReceiverFilter, WZNumberSearch} from "./FilterFields";
import {WZFormSubmit} from "./types";

export function Filters({onSubmit}: {onSubmit: WZFormSubmit}): ReactElement {
    const form = useFormContext();
    const {t} = useTranslation();
    const userContext = useContext(UserContext);

    return (
        <form className="wz-filter-form" onSubmit={form.handleSubmit(onSubmit)}>
            <div className="top-left">
                <DataPeriod />
                {parseInt(form.watch('date-period')) === 4 ? <DateRange /> : null}
            </div>
            <div className="top-right">
                <DocumentType />
                {userContext?.user && userContext.user.receiver.isMain ? <ReceiverFilter /> : null}
            </div>
            <div className="bottom">
                <ProductEAN />
                <ProductIndex />
                <button className="btn">{t('user-page.wzs.filters.button')}</button>
            </div>
        </form>
    );
}

export function Search({onSubmit}: {onSubmit: WZFormSubmit}): ReactElement {
    const form = useFormContext();
    const {t} = useTranslation();

    return (
        <form className="wz-search-form" onSubmit={form.handleSubmit(onSubmit)}>
            <div className="top-left">
                <WZNumberSearch />
                <button className="btn">{t('user-page.wzs.filters.search-button')}</button>
            </div>
        </form>
    );
}
